import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { Link } from 'react-router-dom'
import { IServiceEditStep } from '../../../types/index'
import { IServiceProgramObject } from '../../../types/service-program'

interface IServiceViewHeaderProps {
  steps: IServiceEditStep[]
  serviceId: string
  name: string
  serviceProgram?: IServiceProgramObject
  routeProps: RouteComponentProps<any>
}

const ServiceViewHeader = (props: IServiceViewHeaderProps) => {
  const getCurrentTabUrl = (): string => {
    if (props.routeProps.location.pathname === props.routeProps.match.url) {
      return ''
    }

    const step = props.steps
      .filter(step => step.url !== '')
      .find(step => new RegExp(step.url).test(props.routeProps.location.pathname))

    if (step) {
      return `/${step.url}`
    }
    return ''
  }

  const handleEditRedirect = () => {
    const currentTabUrl = getCurrentTabUrl()
    return currentTabUrl === '/member'
      ? `${props.routeProps.match.url}/edit`
      : `${props.routeProps.match.url}/edit${currentTabUrl}`
  }

  return (
    <div className='col-12 flex flex-row pt3 pb3 justify-between'>
      <div className='flex flex-row items-baseline pl3'>
        <div className='font-blue-grey h2 bold'>{props.name}</div>
        {props.serviceProgram && <div className='h5 font-grey2 ml2'>Service Program: {props.serviceProgram.name}</div>}
      </div>
      <div className='pr3'>
        <Link aria-label='Edit service' className='btn bg-blue-grey rounded mr2' to={handleEditRedirect()}>
          <span className='font-white weight-300'>Edit</span>
        </Link>
      </div>
    </div>
  )
}

export default ServiceViewHeader



// WEBPACK FOOTER //
// ./src/components/services/view/ServiceViewHeader.tsx